export enum DiagnosisTypeEnum {
    Primary = 1,
    Secondary = 2,
    Tertiary = 3,
    Quaternary = 4,
}
